module.exports = __webpack_public_path__ + "static/media/Vector(2).ca491142.svg";